import { ClipboardDocumentListIcon, NameCell, success } from "@";

const copyLink = (link) => {
  navigator.clipboard.writeText(link);
  success("تم نسخ الرابط");
};

// Click-to-copy link with a small icon chip — same vocabulary as the
// gift-orders CopyLinkCell so the family of "copy a link" UIs reads alike.
const LinkCopyCell = ({ link }) => {
  if (!link) {
    return <span className="text-xs text-gray-300 dark:text-gray-600">—</span>;
  }
  return (
    <button
      type="button"
      dir="ltr"
      title={link}
      onClick={() => copyLink(link)}
      className="group inline-flex items-center gap-2 rounded-full bg-emerald-50 py-1 pe-3 ps-1 text-[12px] text-emerald-900 ring-1 ring-emerald-200/80 transition-colors hover:bg-purple-50 hover:text-purple-900 hover:ring-purple-200 dark:bg-emerald-950/30 dark:text-emerald-300 dark:ring-emerald-800/40 dark:hover:bg-purple-950/40 dark:hover:text-purple-300 dark:hover:ring-purple-700/40"
    >
      <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-white text-emerald-700 ring-1 ring-emerald-100 group-hover:text-purple-700 group-hover:ring-purple-100 dark:bg-gray-800 dark:text-emerald-400 dark:ring-emerald-800/40 dark:group-hover:text-purple-300 dark:group-hover:ring-purple-700/40">
        <ClipboardDocumentListIcon className="h-3.5 w-3.5" />
      </span>

      <span className="inline sm:hidden">نسخ</span>
      <span className="hidden truncate sm:inline">
        {link.length > 100 ? `${link.substr(0, 100)}...` : link}
      </span>
    </button>
  );
};

// TanStack column defs — shared by every detail tab; rows expose their label
// under a tab-specific field, so fall through the known ones.
const showDetailColumns = [
  {
    id: "name",
    header: "الاسم",
    cell: ({ row }) => (
      <NameCell
        name={
          row.original.projectName ||
          row.original.classification ||
          row.original.landingPageName ||
          row.original.name ||
          row.original.title
        }
      />
    ),
  },
  {
    id: "link",
    header: "الرابط",
    cell: ({ row }) => <LinkCopyCell link={row.original.link} />,
  },
];

export default showDetailColumns;
